const styles = theme => ({
  root: {
    marginTop: 24,
    marginBottom: 42,
    marginLeft: 26
  },
  lowest: {
    width: 140,
    marginTop: 20,
    marginBottom: 20,
    marginRight: 20
  },
  highest: {
    width: 140,
    marginTop: 20,
    marginBottom: 20
  },
  alignment: {
    textAlign: 'left',
    alignItems: 'left'
  },
  table: {
    maxWidth: 210,
    marginBottom: 42
  },
  button: {
    marginRight: 24
  },
  buttonNext: {
    marginTop: 24
  },
  buttonDistribution: {
    marginTop: 24,
    marginBottom: 24
  },
  population: {
    marginTop: 24,
    marginBottom: 24
  },
  race: {
    marginLeft: 20,
    marginRight: 20,
    width: 140
  },
  textField: {
    width: 'calc(100% - 48px)',
    marginRight: 12,
    marginTop: 36
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/scenes/TextFilter/scenes/Start/styles.js